import { useQueryClient } from 'react-query'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import {
  API_PATH_KINERJA_PROFILE,
  API_PATH_PELAKSANAAN_SCHOOLS,
} from 'api/kinerja/useAPIKinerja'
import { assetUrl } from 'utils/url'

type StepSuccessProps = {
  onClose: () => void
}

export function StepSuccess({ onClose }: StepSuccessProps) {
  const queryClient = useQueryClient()

  const handleClose = () => {
    // Refetch profile and schools endpoint
    queryClient.invalidateQueries(API_PATH_KINERJA_PROFILE)
    queryClient.invalidateQueries(API_PATH_PELAKSANAAN_SCHOOLS)

    onClose?.()
  }

  return (
    <>
      <img
        src={assetUrl('/illustrations/img-files-document-success.png')}
        alt=""
        width="84"
        height="84"
      />
      <div className="space-y-2 mt-4">
        <Text variant="display-sm">Berhasil konfirmasi data!</Text>
        <Text color="subdued">
          Terima kasih atas konfirmasinya. Jika Anda perlu konfirmasi ulang,
          mohon hubungi operator sekolah atau Dinas Pendidikan setempat untuk
          menyesuaikan data di Dapodik.
        </Text>
      </div>
      <Button color="blue" className="mt-6" size="lg" onClick={handleClose}>
        Saya mengerti
      </Button>
    </>
  )
}
